"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuElement = void 0;

var RegionComponent_1 = require("./Component/RegionComponent");
/**
 * The region menu element.
 */


var MenuElement = /*#__PURE__*/function (_RegionComponent_1$Re) {
  _inherits(MenuElement, _RegionComponent_1$Re);

  /**
   * Creates the menu component.
   * @param paper - The `Snap.Paper` object to draw on.
   * @param paperRect - The parent bounding box for created component.
   * @param regionData - The `RegionData` object shared across components. Used also for initial setup.
   * @param callbacks - The external callbacks collection.
   */
  function MenuElement(paper) {
    var _this;

    var paperRect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var regionData = arguments.length > 2 ? arguments[2] : undefined;
    var callbacks = arguments.length > 3 ? arguments[3] : undefined;

    _classCallCheck(this, MenuElement);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuElement).call(this, paper, paperRect, regionData, callbacks));
    /**
     * Default menu item size.
     */

    _this.menuItemSize = 20;
    /**
     * Default menu width.
     */

    _this.mw = _this.menuItemSize + 10;
    /**
     * Default menu height.
     */

    _this.mh = _this.menuItemSize + 10;
    /**
     * Threshold for positioning menu inside/outside
     */

    _this.dh = 20;
    /**
     * Threshold for positioning menu left/right
     */

    _this.dw = 5;

    _this.buildUI();

    return _this;
  }
  /**
   * Add a new icon with action to menu.
   * @param action - Item action description.
   * @param icon - Item SVG-path string.
   * @param actor - The callback function.
   */


  _createClass(MenuElement, [{
    key: "addAction",
    value: function addAction(action, icon, actor) {
      var _this2 = this;

      var item = this.menuGroup.g();
      var itemBack = this.menuGroup.rect(5, 5, this.menuItemSize, this.menuItemSize, 5, 5);
      itemBack.addClass("menuItemBack");
      var itemIcon = this.menuGroup.path(MenuElement.PathCollection.delete.path);
      itemIcon.transform("scale(0.2) translate(26 26)");
      itemIcon.addClass("menuIcon");
      itemIcon.addClass("menuIcon-" + icon);
      var itemRect = this.menuGroup.rect(5, 5, this.menuItemSize, this.menuItemSize, 5, 5);
      itemRect.addClass("menuItem");
      item.add(itemBack);
      item.add(itemIcon);
      item.add(itemRect);
      item.click(function (e) {
        actor(_this2.region, action);
      });
      this.menuItemsGroup.add(item);
      this.menuItems.push(item);
    }
    /**
     * Attach the menu to specified region element.
     * @param region - The host region element.
     */

  }, {
    key: "attachTo",
    value: function attachTo(region) {
      var _this3 = this;

      this.region = region;
      this.regionData.initFrom(region.regionData);
      this.rearrangeMenuPosition();
      window.requestAnimationFrame(function () {
        _this3.menuGroup.attr({
          x: _this3.mx,
          y: _this3.my
        });
      });
    }
  }, {
    key: "move",
    value: function move(arg1, arg2) {
      var _this4 = this;

      _get(_getPrototypeOf(MenuElement.prototype), "move", this).call(this, arg1, arg2);

      this.rearrangeMenuPosition();
      window.requestAnimationFrame(function () {
        _this4.menuGroup.attr({
          x: _this4.mx,
          y: _this4.my
        });
      });
    }
    /**
     * Move menu according to new region size.
     * @remarks This method moves the virtual shadow of the region and then rearranges menu position.
     * @param width - New region width.
     * @param height - New region height.
     */

  }, {
    key: "resize",
    value: function resize(width, height) {
      var _this5 = this;

      _get(_getPrototypeOf(MenuElement.prototype), "resize", this).call(this, width, height);

      this.rearrangeMenuPosition();
      window.requestAnimationFrame(function () {
        _this5.menuGroup.attr({
          x: _this5.mx,
          y: _this5.my
        });
      });
    }
    /**
     * Redraw menu element.
     */

  }, {
    key: "redraw",
    value: function redraw() {// do nothing
    }
    /**
     * Visually hide menu element.
     */

  }, {
    key: "hide",
    value: function hide() {
      var _this6 = this;

      window.requestAnimationFrame(function () {
        _this6.menuGroup.attr({
          visibility: "hidden"
        });
      });
    }
    /**
     * Visually show menu element.
     */

  }, {
    key: "show",
    value: function show() {
      var _this7 = this;

      window.requestAnimationFrame(function () {
        _this7.menuGroup.attr({
          visibility: "visible"
        });
      });
    }
    /**
     * Show menu element on the specified region.
     * @param region - The host region element.
     */

  }, {
    key: "showOnRegion",
    value: function showOnRegion(region) {
      this.attachTo(region);
      this.show();
    }
    /**
     * Creates the menu element UI.
     */

  }, {
    key: "buildUI",
    value: function buildUI() {
      var _this8 = this;

      var menuSVG = this.paper.svg(this.mx, this.my, this.mw, this.mh, this.mx, this.my, this.mw, this.mh); // Snap.Paper

      this.menuGroup = Snap(menuSVG).paper;
      this.menuGroup.addClass("menuLayer");
      this.rearrangeMenuPosition();
      this.menuRect = this.menuGroup.rect(0, 0, this.mw, this.mh, 5, 5);
      this.menuRect.addClass("menuRectStyle");
      this.menuItemsGroup = this.menuGroup.g();
      this.menuItemsGroup.addClass("menuItems");
      this.menuItems = new Array();
      this.menuGroup.add(this.menuRect);
      this.menuGroup.add(this.menuItemsGroup);
      this.menuGroup.mouseover(function (e) {
        _this8.callbacks.onManipulationBegin();
      });
      this.menuGroup.mouseout(function (e) {
        _this8.callbacks.onManipulationEnd();
      });
    }
    /**
     * Updates menu position.
     */

  }, {
    key: "rearrangeMenuPosition",
    value: function rearrangeMenuPosition() {
      /* // position menu inside
      if (this.mh <= this.boundRect.height - this.dh) {
          this.my = this.y + this.boundRect.height / 2 - this.mh / 2;
          // position menu on the right side
          if (this.x + this.boundRect.width + this.mw / 2 + this.dw < this.paperRect.width) {
              this.mx = this.x + this.boundRect.width - this.mw / 2;
          } else if (this.x - this.mw / 2 - this.dw > 0) { // position menu on the left side
              this.mx = this.x - this.mw / 2;
          } else { // position menu on the right side INSIDE
              this.mx = this.x + this.boundRect.width - this.mw - this.dw;
          }
      } else { // position menu outside
          if (this.y + this.mh > this.paperRect.height) {
              this.my = this.paperRect.height - this.mh - this.dw;
          } else {
              this.my = this.y;
          }
          // position menu on the right side
          if (this.x + this.boundRect.width + this.mw + 2 * this.dw < this.paperRect.width) {
              this.mx = this.x + this.boundRect.width + this.dw;
          } else if (this.x - this.mw - 2 * this.dw > 0) { // position menu on the left side
              this.mx = this.x - this.mw - this.dw;
          } else { // position menu on the right side INSIDE
              this.mx = this.x + this.boundRect.width - this.mw - this.dw;
          }
      } */
      // position menu outside
      if (this.y + this.mh + this.dw > this.paperRect.height) {
        this.my = this.paperRect.height - this.mh - this.dw;
      } else {
        this.my = this.y + this.dw;
      } // position menu on the right side


      if (this.x + this.boundRect.width + this.mw + 2 * this.dw < this.paperRect.width) {
        this.mx = this.x + this.boundRect.width + this.dw;
      } else if (this.x - this.mw - 2 * this.dw > 0) {
        // position menu on the left side
        this.mx = this.x - this.mw - this.dw;
      } else {
        // position menu on the right side INSIDE
        this.mx = this.x + this.boundRect.width - this.mw - this.dw;
      }
    }
  }]);

  return MenuElement;
}(RegionComponent_1.RegionComponent);

exports.MenuElement = MenuElement;
/**
 * The SVG path for x-button (close).
 */

MenuElement.PathCollection = {
  delete: {
    iconSize: 96,
    path: "M 83.4 21.1 L 74.9 12.6 L 48 39.5 L 21.1 12.6 L 12.6 21.1 L 39.5 48 L 12.6 74.9 " + "L 21.1 83.4 L 48 56.5 L 74.9 83.4 L 83.4 74.9 L 56.5 48 Z"
  }
};